module.exports = __webpack_public_path__ + "assets/media/install-video-thumbnail.83c752d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/VideoInstallStep/assets/install-video-thumbnail.jpg
// module id = 3247
// module chunks = 0